"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var loginSlice_1 = require("./loginSlice");
var formik_1 = require("formik");
var semantic_ui_react_1 = require("semantic-ui-react");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var react_i18next_1 = require("react-i18next");
var globalSlice_1 = require("../global/globalSlice");
var Divider_1 = __importDefault(require("../../components/Divider"));
var Validation_1 = __importDefault(require("../../components/Validation"));
var BlInput_1 = __importDefault(require("../../components/FormComponents/BlInput"));
var loginSchema_1 = __importDefault(require("../../schemas/loginSchema"));
var Routes_1 = require("../../constants/Routes");
var Button_1 = __importDefault(require("../../components/Button"));
var ErrorMsg_1 = __importDefault(require("../../components/Validation/ErrorMsg"));
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("../../components/FormComponents/BlInput/styles.module.scss"));
var LoginForm = function () {
    var dispatch = react_redux_1.useDispatch();
    var history = react_router_dom_1.useHistory();
    var t = react_i18next_1.useTranslation('common').t;
    var loginIsLoading = react_redux_1.useSelector(loginSlice_1.selectLoginIsLoading);
    var redirectAfterLogin = react_redux_1.useSelector(loginSlice_1.selectRedirectAfterLogin);
    var isModalOpen = react_redux_1.useSelector(loginSlice_1.selectLoginModalIsOpen);
    var _a = react_1.useState(false), isLoginError = _a[0], setIsLoginError = _a[1];
    var _b = react_1.useState(false), revealInput = _b[0], setRevealInput = _b[1];
    react_1.useEffect(function () {
        setIsLoginError(false);
    }, [isModalOpen]);
    var onSubmit = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, dispatch(loginSlice_1.loginUser(values))];
                case 1:
                    _a.sent();
                    redirectAfterLogin
                        ? history.push(Routes_1.Routes.Account.path + Routes_1.Routes.Settings.path)
                        : dispatch(loginSlice_1.closeLoginFormModal());
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    if (e_1.response.status === 406) {
                        history.push(Routes_1.Routes.Verify.path);
                        dispatch(globalSlice_1.addToastMessage({
                            text: t('IF_YOU_WANT_TO_USE_YOUR_PROFILE'),
                            appearance: 'warning',
                        }));
                    }
                    else {
                        setIsLoginError(true);
                    }
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(semantic_ui_react_1.Modal, { onClose: function () {
            dispatch(loginSlice_1.closeLoginFormModal());
        }, onOpen: function () {
            dispatch(loginSlice_1.openLoginFormModal({ redirectAfterLogin: true }));
        }, onMount: function () { return document.body.classList.add('login-modal'); }, onUnmount: function () { return document.body.classList.remove('login-modal'); }, open: react_redux_1.useSelector(loginSlice_1.selectLoginModalIsOpen), className: "wrap" },
        react_1.default.createElement(semantic_ui_react_1.Modal.Content, null,
            react_1.default.createElement("span", { className: "close-login-modal" },
                react_1.default.createElement("i", { onClick: function () {
                        dispatch(loginSlice_1.closeLoginFormModal());
                    }, className: "cm-icon icon-close" })),
            react_1.default.createElement("h2", null, t('WELCOME')),
            react_1.default.createElement("p", { className: "title" }, t('SING_IN_TO_CONTINUE')),
            react_1.default.createElement(formik_1.Formik, { initialValues: {
                    email: '',
                    password: '',
                    remember_me: false,
                }, validationSchema: loginSchema_1.default, onSubmit: function (values) {
                    onSubmit(values);
                    setIsLoginError(false);
                } }, function (formik) { return (react_1.default.createElement(formik_1.Form, { className: "login-form" },
                react_1.default.createElement("div", { className: "validation-form-group" },
                    react_1.default.createElement(Validation_1.default, { name: "email", formikProps: formik },
                        react_1.default.createElement(BlInput_1.default, __assign({ className: "form-row", icon: "email", type: "text", placeholder: t('FORM_ITEMS.EMAIL'), rounded: true, required: true }, formik.getFieldProps('email'), { onChange: function (e) {
                                formik.setFieldValue('email', e.target.value
                                    .toLowerCase()
                                    .trim());
                            } })))),
                react_1.default.createElement("div", { className: "validation-form-group" },
                    react_1.default.createElement(Validation_1.default, { name: "password", formikProps: formik },
                        react_1.default.createElement(BlInput_1.default, __assign({ className: "form-row", icon: "password", type: revealInput ? 'text' : 'password', placeholder: t('FORM_ITEMS.PASSWORD'), rounded: true, required: true, element: react_1.default.createElement("i", { className: classnames_1.default(styles_module_scss_1.default.password_eye, {
                                    'icon-view': !revealInput,
                                    'icon-ic-hide-pass': revealInput,
                                }), onClick: function () {
                                    setRevealInput(!revealInput);
                                } }) }, formik.getFieldProps('password'), { onChange: function (e) {
                                formik.setFieldValue('password', e.target.value.trim());
                            } })))),
                react_1.default.createElement("div", { className: 'validation-form-group form-checkbox' },
                    react_1.default.createElement("div", { className: "form-row" },
                        react_1.default.createElement(semantic_ui_react_1.Checkbox, { id: "remember_me", label: t('REMEMBER_ME'), checked: formik.values.remember_me, onChange: formik.handleChange('remember_me') }))),
                isLoginError && (react_1.default.createElement("div", { className: "response-error-message" },
                    react_1.default.createElement(ErrorMsg_1.default, { message: t('login.INCORRECT_EMAIL_PASSWORD') }))),
                react_1.default.createElement(Button_1.default, { type: "submit", loading: loginIsLoading, disabled: loginIsLoading }, t('FORM_ITEMS.SIGN_IN')),
                react_1.default.createElement(react_router_dom_1.Link, { to: Routes_1.Routes.ForgotPassword.path, className: "forget-pass", onClick: function () {
                        dispatch(loginSlice_1.closeLoginFormModal());
                    } }, t('FORGOT_YOUR_PASSWORD')),
                react_1.default.createElement(Divider_1.default, null),
                react_1.default.createElement(react_router_dom_1.Link, { onClick: function () {
                        dispatch(loginSlice_1.closeLoginFormModal());
                    }, className: "btn btn-outline-primary", to: Routes_1.Routes.Registration.path }, t('FORM_ITEMS.SIGN_UP')))); }))));
};
exports.default = LoginForm;
